<template>
  <View gap="sm" align="center" wrap="wrap">
    <Icon name="alert-triangle" size="small" class="icon" />
    <Text variant="body-medium" color="secondary">{{ message }}</Text>
    <Button variant="outline" size="small" :loading="loading" @click="emit('retry')">Retry</Button>
  </View>
</template>

<script setup lang="ts">
import { Button, Icon, Text, View } from '@tallo/design-system';

defineProps<{ message: string; loading?: boolean }>();
const emit = defineEmits<{ retry: [] }>();
</script>

<style scoped lang="scss">
.icon {
  color: var(--t-color-red-500);
}
</style>
